import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Flutter = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="m2 7.992 2.098 2.094 8.816-8.753H8.717L2 7.992Zm7.68 3.514 3.112 3.16H8.631L7.59 13.583l2.09-2.077Zm-2.55 1.641-2.094-2.094 3.611-3.598h4.19L7.13 13.147Z"
      fill="currentColor"
    />
  </Icon>
));

export default Flutter;
